import React from 'react';

import { useConfigStore } from '@packages/stores';

import { Assets } from '@assets';
import { Button } from '@elements/button';
import { Text } from '@elements/text';
import { i18n } from '@i18n';

export const StopSell: React.FC = () => {
  const content = useConfigStore(
    state => state?.regionSpecificConfig?.FEATURE_TOGGLE?.addTrip?.disabledMessage,
  );

  return (
    <div className="bg-nusa-200 flex h-screen w-screen flex-col items-center justify-center space-y-7 px-4 text-center">
      <Assets.Tools />
      <Text variant="h2-36/sb">{content?.title}</Text>
      <Text variant="body-16/m">{content?.subtitle}</Text>
      <div className="max-w-2xl border-y border-fuji-800 border-opacity-20 p-7 text-center">
        <Text variant="subHeading-14/m">{i18n.t('stopSell.emergencyAssistantLabel')}</Text>
        <a href={`tel: ${i18n.t('stopSell.emergencyNumber')}`} className="w-full">
          <Button variant="primary" className="mt-6" title={i18n.t('stopSell.emergencyNumber')} />
        </a>
      </div>
    </div>
  );
};
